import { Typography } from '@mui/material';
import { CronoMenuItem, CronoSelect } from 'crono-fe-common/components/Select';
import { COUNTRIES } from 'crono-fe-common/constants/constants';
import { colors } from 'crono-fe-common/theme';

interface IPropsBillingCountryPicker {
  value: string;
  onChange: (value: string) => void;
}

const BillingCountryPicker = ({
  value,
  onChange,
}: IPropsBillingCountryPicker) => {
  return (
    <>
      <CronoSelect
        sx={{
          boxShadow: 'none',
          '.MuiOutlinedInput-notchedOutline': {
            borderRadius: '8px',
            border: `1px solid ${colors.grey444}`,
          },
          fontSize: 14,
          lineHeight: '20px',
          fontWeight: 500,
          height: '40px',
        }}
        value={value}
        onChange={(event) => {
          onChange(event.target.value as string);
        }}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return 'Select a country';
          }
          const selectedCountry = COUNTRIES.find(
            (country) => country.value === selected,
          );
          return selectedCountry ? selectedCountry.title : '';
        }}
      >
        {COUNTRIES.map((country) => {
          return (
            <CronoMenuItem key={country.value} value={country.value}>
              {country.title}
            </CronoMenuItem>
          );
        })}
      </CronoSelect>
      <Typography
        fontSize={12}
        lineHeight={'16px'}
        fontWeight={500}
        color={colors.grey11}
      >
        *This can't be changed later
      </Typography>
    </>
  );
};

export default BillingCountryPicker;
